var _linearGradient, _path, _linearGradient2, _polygon, _linearGradient3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Filter502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LQecDGgtNJsa9MZsP1Ht2a",
    x1: 4,
    x2: 44,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42a3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42a4eb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LQecDGgtNJsa9MZsP1Ht2a)",
    d: "M42,10H6c-1.105,0-2-0.895-2-2v0c0-1.105,0.895-2,2-2h36c1.105,0,2,0.895,2,2v0 C44,9.105,43.105,10,42,10z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LQecDGgtNJsa9MZsP1Ht2b",
    x1: 7.593,
    x2: 41.821,
    y1: 18.5,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#LQecDGgtNJsa9MZsP1Ht2b)",
    points: "28,27 20,27 7,10 41,10"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LQecDGgtNJsa9MZsP1Ht2c",
    x1: 20,
    x2: 28,
    y1: 35.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d59b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195bbc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LQecDGgtNJsa9MZsP1Ht2c)",
    d: "M28,27h-8v15.999c0,0.743,0.782,1.227,1.447,0.894l5.447-2.724 C27.572,40.831,28,40.138,28,39.381V27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Filter502);
export default __webpack_public_path__ + "static/media/icons8-filter-50-2.b9b48c9899957c21339cd77e37c2a182.svg";
export { ForwardRef as ReactComponent };